import { EventsComponent } from './../events/events.component';
import { Component, HostBinding, OnInit, AfterViewInit, Injector, ElementRef } from '@angular/core';
import { map, startsWith, isEmpty, orderBy, forEach } from 'lodash';
import * as bowser from 'bowser';
import { isNull } from 'util';

@Component({
	selector: 'multi-select',
	template: `
		<div
			class=" multidropdown-container"
			[ngClass]="{
				'drp-disabled': control.disabled,
				error: error
			}"
		>
			<ng-select
				[items]="control.options"
				[closeOnSelect]="shouldCloseOnSelect"
				[searchable]="true"
				[multiple]="true"
				maxSelectedItems="{{ setMaxSelectedItems() }}"
				[searchFn]="getSearchFn()"
				bindLabel="title"
				[disabled]="control.disabled"
				[clearable]="false"
				(blur)="onBlur()"
				(change)="updateAnswer($event)"
				[placeholder]="control.attributes.placeholder"
				[(ngModel)]="viewValue"
				gtm-handler
				[attr.gtm]="gaLabel"
				events="click"
				handlerType="dataValue"
				[label]="gaLabel + 'Selected'"
				action="DropDownChange"
				[value]="gaValue"
			>
			</ng-select>

			<div class="mobile-dropdown" [ngClass]="{ disabled: control.disabled }">
				<span></span>
				<select
					[(ngModel)]="viewValue"
					[disabled]="control.disabled"
					[attr.aria-describedby]="control.name.split('.').join('_') + '_error'"
					*ngFor="let option of control.options"
				></select>
				<span></span>
			</div>
		</div>
	`,
	styleUrls: ['./multiselect.component.scss'],
})
export class MultiSelectComponent extends EventsComponent implements OnInit, AfterViewInit {
	viewValue: any;
	multiValue: any[];
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	isMobile: boolean;
	fullAutocomplete = false;
	shouldCloseOnSelect = false;
	lastSelectedChar: any;
	selectedOptions: any[] = [];
	placeholder: string;
	firstOnNoResultsValue: boolean;
	filterCount: number = 0;
	isAtLeastOneMatch: boolean;
	gaValue;

	constructor(injector: Injector, private el: ElementRef) {
		super(injector);
	}

	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		this.gaValue = this.getGaValue();
		if (this.value) {
			this.reportPrefill();
		}

		const bowserType = bowser.getParser(window.navigator.userAgent).getPlatformType();

		this.isMobile = bowserType === 'mobile' || bowserType === 'tablet';
		this.el.nativeElement.classList.add(`col-${this.control.width}`);
		if (this.control.attributes) {
			this.el.nativeElement.classList.add(`${this.control.attributes.class}`);
			this.fullAutocomplete = this.control.attributes.fullAutocomplete;
			this.shouldCloseOnSelect = this.control.attributes.fullAutocomplete;
			this.firstOnNoResultsValue = this.control.attributes.firstOnNoResultsValue;
		}
		this.control.options = orderBy(this.control.options, 'sequence');

		const value = this.setValue(this.value);
		if (value.length > 0) {
			this.viewValue = value;
		}

		this.observablesService.pageUpdatedFinished.subscribe(() => {
			if (this.control && this.control.options) {
				this.control.options = orderBy(this.control.options, 'sequence');
			}
		});
	}

	setValue(value) {
		if (isNull(value)) {
			return [];
		}

		const list = value.map((item) => {
			for (const option of this.control.options) {
				if (option.value === item) {
					return option.title;
				}
			}
		});

		if (list.length > 0) {
			this.selectedOptions = list;
			return this.selectedOptions;
		} else {
			return this.selectedOptions;
		}
	}

	public getGaValue(): string {
		return this.value && this.value.length ? this.value.join(', ') : '';
	}

	updateAnswer(item) {
		this.multiValue = [];
		map(item, (e: any) => {
			this.multiValue.push(e.value);
		});
		this.setAnswer(this.multiValue);
		this.value = this.setValue(this.multiValue);
	}

	setPlaceHolder() {
		this.viewValue = this.setValue(this.value);
		return this.control.attributes.placeholder;
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();

		const elem = this.elementRef.nativeElement.querySelectorAll('input')[0];
		this.Renderer.setAttribute(elem, 'id', this.control.name.split('PolicyData.').join(''));
		this.Renderer.setAttribute(elem, 'aria-describedby', this.control.name + '_error');
		this.fullAutocomplete = true;
		if (!this.fullAutocomplete) {
			elem.addEventListener('keydown', () => {
				setTimeout(() => {
					this.listScrollItems();
				});
			});

			elem.addEventListener(
				'keypress',
				() => {
					setTimeout(() => {
						if (this.lastSelectedChar === elem.value) {
							const options = this.elementRef.nativeElement.querySelectorAll('.ng-dropdown-panel-items .ng-option');
							let markedOption = null;
							forEach(options, (opt, index) => {
								if (opt.className.includes('ng-option-marked')) {
									markedOption = index;
								}
							});
							if (options.length === markedOption + 1) {
								this.Renderer.addClass(options[0], 'ng-option-marked');
							} else {
								this.Renderer.addClass(options[markedOption + 1], 'ng-option-marked');
							}
							this.Renderer.removeClass(options[markedOption], 'ng-option-marked');
						}
						this.lastSelectedChar = elem.value;
						elem.value = '';
						this.Renderer.setValue(elem, '');
					});
				},
				0
			);
		}
	}

	getSearchFn() {
		this.filterCount = 0;
		this.isAtLeastOneMatch = false;
		return this.firstOnNoResultsValue
			? this.customNoItemsTextFilterFirst.bind(this)
			: this.customNoItemsTextFilterFn.bind(this);
	}

	filterByFirstChar(term: string, item: any) {
		return startsWith(item.value.toLowerCase(), term.toLowerCase());
	}

	customNoItemsTextFilterFirst(term: string, item: any): boolean {
		if (isEmpty(term.trim())) {
			this.filterCount++;
			return item;
		}
		const isMatch = this.checkItemMatch(term, item);
		if (isMatch) {
			return isMatch;
		} else {
			if (this.filterCount === 0) {
				this.filterCount++;
				return !this.checkMatch(term) ? true : false;
			}
			this.filterCount++;
		}
	}

	checkItemMatch(term: string, item: any): boolean {
		return item.title.trim().toLowerCase().includes(term.trim().toLowerCase());
	}

	checkMatch(term: string) {
		let list = this.control.options;
		for (let i = 1; i < list.length; i++) {
			if (this.checkItemMatch(term, list[i])) {
				return true;
			}
		}
		return false;
	}

	customNoItemsTextFilterFn(term: string, item: any): boolean {
		this.filterCount++;
		if (isEmpty(term.trim())) {
			return item;
		}
		const isMatch = this.checkItemMatch(term, item);
		if (isMatch) {
			this.isAtLeastOneMatch = true;
			return isMatch;
		} else {
			if (this.filterCount === this.control.options.length && !this.isAtLeastOneMatch) {
				return true;
			}
		}
	}

	setMaxSelectedItems() {
		return this.control.attributes && this.control.attributes.maxLength
			? this.control.attributes.maxLength
			: this.control.options.length;
	}

	listScrollItems() {
		const scrollContents = this.elementRef.nativeElement.querySelectorAll('.ng-dropdown-panel-items')[0];
		const option = scrollContents.querySelector('.ng-option-marked');
		if (option) {
			const dropdownHeight = scrollContents.offsetHeight;
			const optionHeight = option.offsetHeight;
			const optionTop = option.offsetTop;
			const optionBottom = optionTop + option.offsetHeight;
			const scrollBottom = scrollContents.scrollTop + dropdownHeight;
			if (optionBottom > scrollBottom) {
				scrollContents.scrollTop = optionTop - (dropdownHeight - optionHeight);
			}
		}
	}

	onBlur() {
		if (this.fullAutocomplete) {
			this.lastSelectedChar = '';
		}
	}
}
